import Vue from 'vue';
// 注册一个全局自定义指令 `v-perm`
Vue.directive('perm', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: (el, binding, vnode) => {
        const value = binding.value;
        let permissions = localStorage.getItem('permissions');
        if (permissions){
            let auths = JSON.parse(permissions);
            if (auths && auths.join(",").indexOf(value)==-1) {
                //如果登录人没有该按钮权限就移除该按钮
                el.parentNode.removeChild(el);
            }
        }
    }
});


// WEBPACK FOOTER //
// ./src/common/js/permissions.js